module.exports = __webpack_public_path__ + "static/media/3.8f625aac.jpg";